import React from "react";

import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useString, useStrings } from "../../../../localization/localizationHelpers";

import { LandingCtaPlacements, useLandingCta } from "../../useLandingCta";
import * as styles from "./PartnerReachSection.module.css";

type FeatureProps = Readonly<{
  title: string;
  description: string;
}>;

const Feature = ({ title, description }: FeatureProps) => (
  <div className={styles.feature}>
    <h3 className={styles.featureTitle}>{title}</h3>
    <p className={styles.featureDescription}>{description}</p>
  </div>
);

export const PartnerReachSection = () => {
  const handleGetStarted = useLandingCta(LandingCtaPlacements.reach);

  const [
    eyebrow,
    title,
    playersTitle,
    playersDescription,
    bulletConsoles,
    bulletPc,
    bulletCloud,
    getStartedLabel,
    globalTitle,
    globalDescription,
    portingTitle,
    portingDescription,
    cloudTitle,
    cloudDescription,
    xpaTitle,
    xpaDescription,
  ] = useStrings(
    "landingReachEyebrow",
    "landingReachTitle",
    "landingReachPlayersTitle",
    "landingReachPlayersDescription",
    "landingReachBulletConsoles",
    "landingReachBulletPc",
    "landingReachBulletCloud",
    "landingHeroGetStartedButton",
    "landingReachGlobalTitle",
    "landingReachGlobalDescription",
    "landingReachPortingTitle",
    "landingReachPortingDescription",
    "landingReachCloudTitle",
    "landingReachCloudDescription",
    "landingReachXpaTitle",
    "landingReachXpaDescription"
  );

  const devicesImageAlt = useString("landingReachDevicesImageAlt");

  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <header className={styles.cardHeader}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div className={styles.highlight}>
          <div className={styles.highlightContent}>
            <h3 className={styles.highlightTitle}>{playersTitle}</h3>
            <p className={styles.highlightDescription}>{playersDescription}</p>
            <ul className={styles.bulletList}>
              <li>{bulletConsoles}</li>
              <li>{bulletPc}</li>
              <li>{bulletCloud}</li>
            </ul>
            <button className={styles.getStartedButton} onClick={handleGetStarted}>
              {getStartedLabel}
            </button>
          </div>
          <div className={styles.highlightMedia}>
            <img
              className={styles.highlightImage}
              src={getImage("landing_devices", ImageType.Png)}
              alt={devicesImageAlt}
            />
          </div>
        </div>
        <div className={styles.featureGrid}>
          <Feature title={globalTitle} description={globalDescription} />
          <Feature title={portingTitle} description={portingDescription} />
          <Feature title={cloudTitle} description={cloudDescription} />
          <Feature title={xpaTitle} description={xpaDescription} />
        </div>
      </div>
    </section>
  );
};
